import type { ReactNode } from 'react';

import { CAPSULE_ICON_STRINGS } from 'src/consts';

import { useAnimationState } from './animationState';
import { GreenPillDesign, InnerAnimatedContent, LightGreenPillDesign, StyledCard, YellowPillDesign } from './styles';

interface AnimatedCardProps {
  children: ReactNode;
  /**
   * variant is a string value of 'base' or 'condensed'.
   * - optional, defaults to base and adds appropriate card margin
   */
  variant?: 'base' | 'condensed';
  /**
   * design is a string value of 'base' or 'pills'.
   * - optional, defaults to base and adds appropriate card design style
   */
  design?: 'base' | 'pills';
}

const AnimatedCard = ({ children, variant = 'base', design = 'base' }: AnimatedCardProps) => {
  const { animationState } = useAnimationState();
  return (
    <StyledCard cardExpand={animationState.expand} variant={variant} dataTestid={'animated-card'} design={design}>
      {design === 'pills' && (
        <>
          <YellowPillDesign iconString={CAPSULE_ICON_STRINGS.pill_tall} raw />
          <LightGreenPillDesign iconString={CAPSULE_ICON_STRINGS.pill_section} raw />
          <GreenPillDesign iconString={CAPSULE_ICON_STRINGS.pill_section} raw />
        </>
      )}
      <InnerAnimatedContent innerCardExpand={animationState.expand}>{children}</InnerAnimatedContent>
    </StyledCard>
  );
};

export { AnimatedCard };
